import { apiRequest } from "./apiClient";

export type UploadResult = {
  readonly success: boolean;
  readonly error?: string;
};

function parseUploadErrorBody(body: unknown): string {
  if (!body || typeof body !== "object") {
    return "Upload failed";
  }
  const detail = (body as { detail?: unknown }).detail;
  if (typeof detail === "string") {
    return detail;
  }
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0];
    if (
      first &&
      typeof first === "object" &&
      "msg" in first &&
      typeof (first as { msg: string }).msg === "string"
    ) {
      return (first as { msg: string }).msg;
    }
  }
  return "Upload failed";
}

export const uploadContract = async (
  file: File,
  contractCategory: string
): Promise<UploadResult> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("contract_type", contractCategory);

  try {
    await apiRequest("/contracts/upload", {
      method: "POST",
      body: formData,
    });
    return { success: true };
  } catch (error) {
    const message = error instanceof Error ? error.message : "Upload failed";
    return { success: false, error: parseUploadErrorBody({ detail: message }) };
  }
};
